export default {
  containers: {
    location_info: 'Informații locație',
    attributes: 'Atribute',
    links: 'Linkuri',
  },
  labels: {
    title: 'Titlu',
    phone_number: 'Număr de telefon',
    description: 'Descriere',
    website: 'Website',
    address: 'Adresă',
    regular_hours: 'Program regulat',
    page_urls: 'URL-uri pagină',
    monday: 'Luni',
    tuesday: 'Marți',
    wednesday: 'Miercuri',
    thursday: 'Joi',
    friday: 'Vineri',
    saturday: 'Sâmbătă',
    sunday: 'Duminică',
    twenty_four_hours: '24ore',
    open_24_hours: 'Deschis 24 de ore',
    open_time: 'Ora deschiderii',
    close_time: 'Ora închiderii',
    url: 'URL',
    provider_type: 'Tip furnizor',
    provider_types: {
      merchant: 'Comerciant',
      aggregator: 'Agregator',
    },
    place_action_type: 'Tip',
    is_preferred: 'Preferat',
    place_action_types: {
      appointment: 'Programare la o întâlnire',
      online_appointment: 'Programare online',
      dining_reservation: 'Link rezervări',
      food_ordering: 'Comandă mâncare la livrare și/sau ridicare',
      food_delivery: 'Link livrare',
      food_takeout: 'Link ridicare',
      shop_online: 'Cumpărături, cu livrare și/sau ridicare',
    },
    no_links: 'Niciun link disponibil pentru această afacere',
    url_menu: 'Link meniu',
    url_reservations: 'Link rezervări',
  },
  placeholders: {
    title: 'Titlu',
    phone_number: 'Număr de telefon',
    description: 'Descriere',
    website: 'Website',
    address: 'Adresă',
    regular_hours: 'Program regulat',
    page_urls: 'URL-uri pagină',
    address_line_1: 'Adresă linia 1',
    postal_code: 'Cod poștal',
    locality: 'Localitate',
    region_code: 'Cod regiune',
    language_code: 'Cod limbă',
    select_time: 'Selectează ora',
    url: 'URL',
  },
  buttons: {
    submit: 'Trimite',
    add: 'Adaugă',
    delete: 'Șterge',
    generate_description: 'Generare descriere AI',
  },
  validation: {
    required: 'Acest câmp este obligatoriu',
    invalid_url: 'URL invalid',
  },
  toasts: {
    success: 'Modificările au fost salvate!',
    description_generation_failed: 'Nu s-a putut genera o descriere. Încearcă din nou.',
  },
};
